import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFolder$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFolder extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a97f6576c35348d9c4821f7ea96be96324b2aeff', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '4e9664d2450e214d55ffa6887e951670ff49b93f', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '59db0a2b3a84be5ea61ca1846e3cfa09bbe75538', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m10 5.5.87 1.72a.5.5 0 0 0 .44.28h7.19v9h-15v-11zM2.5 4a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5H12l-.87-1.72a.5.5 0 0 0-.49-.28z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-folder", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-folder"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-folder":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFolder$1);
            }
            break;
    } });
}

const CosmosIconFolder = CosmosIconFolder$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFolder, defineCustomElement };
